import type { AddressType } from '~/models';
import { AddressTypeEnum } from '~/models';

export const addressTypeMap: Record<AddressType, number> = {
  [AddressTypeEnum.SHIPPING]: 2,
  [AddressTypeEnum.BILLING]: 1
};
